var overview_popup = (function( $ ) {

	var transition_time = 400;

	var _init = function() {
		var $popup_links = $( 'a.overview-popup' );

		if ( $popup_links.length > 0 ) {
			$popup_links.on( 'click', _get_popup );
		}
	};

	var _get_popup = function( e ) {
		e.preventDefault();

		var data = {
			action : 'crate_get_overview_popup',
			nonce  : ScriptData.crate_get_overview_popup_nonce,
			course_id : $( this ).data( 'id' )
		};

		$.get( ScriptData.ajaxurl, data, _get_popup_response );
	};

	var _get_popup_response = function( response ) {
		if ( response.success ) {
			$( 'body' ).append( response.html );
			$( '#overview-popup' ).fadeIn( transition_time );
			_attach_popup_handlers();
		}
	};

	var _attach_popup_handlers = function() {
		$( '#overview-popup' ).find( '.close' ).on( 'click', _remove_popup );
	};

	var _remove_popup = function( e ) {
		e.preventDefault();

		$( '#overview-popup' ).fadeOut( transition_time );

		setTimeout( function() {
			$( '#overview-popup' ).remove();
		}, transition_time );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = overview_popup;